<div class="nty-cm-tiered-page">
  <img src="assets/nty-cm-tiered-page-graphic.png" class="nty-cm-tiered-page__image" alt="" />
  <div class="nty-cm-tiered-page__content">
    <div class="nty-cm-tiered-page__headline terra-headline-3-light">
      <ng-content select="[nty-cm-headline]" />
    </div>
    <div class="nty-cm-tiered-page__description terra-body">
      <ng-content select="[nty-cm-description]" />
    </div>
  </div>
  <div class="nty-cm-tiered-page__upsell terra-body">
    <ng-content select="nty-cm-button" />
  </div>
  <div class="nty-cm-tiered-page__hyperlink terra-body">
    <ng-content select="nty-cm-a" />
  </div>
</div>
